'use client'

import { ChevronUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { PortalDownloadsToggle } from '@/components/portal-downloads-toggle'
import { useAssetPopupStore } from '@/lib/store/asset-popup-store'
import styles from './floating-actions.module.scss'

export interface FloatingActionsProps {
  showScrollToTop: boolean
  onScrollToTop: () => void
}

export function FloatingActions({ showScrollToTop, onScrollToTop }: FloatingActionsProps) {
  const isPopupOpen = useAssetPopupStore((state) => state.isOpen)

  return (
    <div className={styles.container}>
      {!isPopupOpen && <PortalDownloadsToggle />}
      {showScrollToTop && (
        <Button
          className={styles.scrollToTopButton}
          type="button"
          title="Scroll to top"
          aria-label="Scroll to top"
          size="icon"
          variant="ghost"
          shape="rounded"
          onClick={onScrollToTop}
        >
          <ChevronUp className="tw-h-5 tw-w-5" />
        </Button>
      )}
    </div>
  )
}
